import {
  BooleanParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';

import { BrandParam } from '@/utils/query/params';

export const queryParams = {
  desc: withDefault(BooleanParam, true),
  before: StringParam,
  after: StringParam,
  first: NumberParam,
  brand: BrandParam,
  depositNumber: StringParam,
  country: StringParam,
  currency: StringParam,
  affiliateId: StringParam,
};
